<template>
  <div>
    <!-- <Main /> -->
    <router-view />
  </div>
</template>

<script>
import Main from "@/components/Main/Main";
import Header from "@/components/Header/Header";
export default {
  name: "Anyu",
  data() {
    return {};
  },
  components: {
    // Main,
    // Header,
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/AnYu/AnYu.vue